import { render, staticRenderFns } from "./sideNav.vue?vue&type=template&id=0b446cb8&scoped=true"
import script from "./sideNav.vue?vue&type=script&lang=js"
export * from "./sideNav.vue?vue&type=script&lang=js"
import style0 from "./sideNav.vue?vue&type=style&index=0&id=0b446cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b446cb8",
  null
  
)

export default component.exports